// Разбор спектра трека на полосы частот.
// Используется плеером, чтобы менять направление движения по преобладающей частоте.

// Границы полос в бинах (fftSize = 256 -> 128 бинов)
export const LOW_BAND = [0, 10]; // низкие (бас)
export const MID_BAND = [10, 40]; // средние
export const HIGH_BAND = [40, 110]; // высокие

export function averageBand(data, from, to) {
  if (!data || !data.length) return 0;
  const start = Math.min(from, data.length);
  const end = Math.min(to, data.length);
  if (end <= start) return 0;

  let sum = 0;
  for (let i = start; i < end; i++) sum += data[i];
  return sum / (end - start);
}

// Преобладающая полоса: 'low' | 'mid' | 'high'
export function pickDominantBand(data) {
  const low = averageBand(data, LOW_BAND[0], LOW_BAND[1]);
  const mid = averageBand(data, MID_BAND[0], MID_BAND[1]);
  const high = averageBand(data, HIGH_BAND[0], HIGH_BAND[1]);

  const leader = low >= mid && low >= high ? 'low' : (high >= mid ? 'high' : 'mid');

  return { low, mid, high, leader };
}

// Направление движения для полосы:
// низкие -> 1 (вперёд), высокие -> -1 (назад), средние -> null (не меняем)
export function directionForBand(band) {
  if (band === 'low') return 1;
  if (band === 'high') return -1;
  return null;
}
